module.exports = __webpack_public_path__ + "img/qgbqs-mfi_32-50.prt.22ed10c9.jpg";